import { useTranslate } from "ra-core";

import {
  ExpedienteTextInput,
  type ExpedienteFieldGroupProps,
} from "./ExpedienteField";

/**
 * Persona moral fields of the Expediente: razon social, RFC (12 characters) and the legal
 * representative. The acta constitutiva and the poder are uploaded in the documents block.
 */
export const ExpedientePersonaMoralFields = (
  props: ExpedienteFieldGroupProps,
) => {
  const translate = useTranslate();
  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-lg font-semibold">
        {translate("crm.contact_expediente.section_moral")}
      </h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <ExpedienteTextInput {...props} field="legal_name" />
        <ExpedienteTextInput {...props} field="rfc" maxLength={12} />
        <ExpedienteTextInput {...props} field="legal_representative_name" />
      </div>
    </section>
  );
};
